import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);

export default class Sliders {
    constructor() {
        this.init();
    }

    init() {

        let swiper = new Swiper('.swiper--home', {
            slidesPerView: 1,
            spaceBetween: 100,
            navigation: {
                nextEl: '.swiper-home-events .swiper-button-next',
                prevEl: '.swiper-home-events .swiper-button-prev',
            },
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    spaceBetween: 50,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 50,
                },
                1280: {
                    slidesPerView: 4,
                    spaceBetween: 50,
                },
            }
        });

        let swiperInstagram = new Swiper('.swiper--instagram', {
            slidesPerView: 1,
            spaceBetween: 50,
            navigation: {
                nextEl: '.swiper--instagram--navigation .swiper-button-next',
                prevEl: '.swiper--instagram--navigation .swiper-button-prev',
            },
            breakpoints: {
                // when window width is >= 768px
                640: {
                    slidesPerView: 2,
                    spaceBetween: 100,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 100,
                },
                1280: {
                    slidesPerView: 4,
                    spaceBetween: 100,
                },
            }
        });

        let swiperEvent = new Swiper('.swiper-event-medias', {
            navigation: {
                nextEl: '.swiper--event--navigation.swiper-button-next',
                prevEl: '.swiper--event--navigation.swiper-button-prev',
            },
        });

        let swiperPage = new Swiper('.swiper-page', {
            navigation: {
                nextEl: '.swiper--page--navigation .swiper-button-next',
                prevEl: '.swiper--page--navigation .swiper-button-prev',
            },
        });
    }
}
